<app-q2-feedback-layout quarter="q2">
  <div class="content">
    <div class="arrow-wrap">
      <img *ngIf="currentSlide > 0" class="rotated arrow" src="assets/img/game/arrow-right.svg" (click)="prevShop()">
      <img *ngIf="currentSlide === 0" class="rotated arrow" src="assets/img/game/arrow-right-disabled.svg">
    </div>
    <swiper-container #swiperQ2Feedback init="false">
      <swiper-slide>
        <app-q-comparison *ngIf="game_state" [data]="getQComparisonData()" [quarter]="'Q2'"></app-q-comparison>
      </swiper-slide>
      <swiper-slide>
        <app-q-effective [data]="game_state.q2_summary.leastEffective" effectiveness="Least"></app-q-effective>
      </swiper-slide>
      <swiper-slide>
        <app-q-effective [data]="game_state.q2_summary.mostEffective" effectiveness="Most"></app-q-effective>
      </swiper-slide>
      <swiper-slide>
        <app-q-hint [hint]="game_state.q2_summary.hint"></app-q-hint>
      </swiper-slide>
    </swiper-container>
    <div class="arrow-wrap right">
      <img *ngIf="currentSlide < 3" class="arrow" src="assets/img/game/arrow-right.svg" (click)="nextShop()">
      <img *ngIf="currentSlide >= 3" class="arrow" src="assets/img/game/arrow-right-disabled.svg">
    </div>
    <app-button-bg
      *ngIf="currentSlide === 3" class="btn"
      img="/assets/img/game/begin-bg.svg" (click)="onContinueClick()"
    >
      <div class="btn-inside">Continue</div>
    </app-button-bg>
    <app-button-bg
      *ngIf="currentSlide < 3" class="btn"
      img="/assets/img/game/begin-bg-gray.svg"
      [disabled]="true"
    >
      <div class="btn-inside">Continue</div>
    </app-button-bg>
  </div>
</app-q2-feedback-layout>